// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1%<mLejyHVi+J%e+deN9J3yQ8I7@72iEn7++k2<RVVo)[,<aLcj<Jp+:zZieN7pmncR-4,L-1So,f%HQ1!Q@o2eRnpjttVn!3VR)n,HRHpR:Bp_Sfe+SV>n+R>e!Z9y,<peVa>y:4>H%8eL<@2_Vp9Y%n6JFH3_%n7>ryVnQL,QeKS+Qye7cmkiR:%pf;pnR)>Q-E2i-!IRQ;9Q!66iRF%%d6%7!)9K-Q>%X<2p@)Ii-)>N-FIp!66<-@6<!6>QXv2%!:2i-vI%!)>jL<27@:9K9vaj@FpbX<>KX<6<!$2g-:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll';
